import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Bg from '../Images/photo2/S__25870371.jpg';
import { RxCheckCircled } from 'react-icons/rx';

const SectionWhy = (props) => {
  return (
    <>
      <section className="section bg-img position-relative" id="why" style={{ backgroundImage: 'url(' + Bg + ')' }}>
        <div className='overlay-primary'></div>
        <Container className='p-5 pb-0 overlay-content text-white'>
          <h2 className="text-center font-header mb-4">WHY US</h2>
          <Row className='fs-5'>
            {props.contents.map((item, index) => (
            <Col xs={12} md={6} className='px-0 px-md-5 mb-5'>
              <div className="d-flex align-items-stretch">
                <div className='me-3'><RxCheckCircled size={50} /></div>
                <p dangerouslySetInnerHTML={{ __html: item.set1 }}></p>
              </div>
            </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  )
}

SectionWhy.defaultProps = {
  contents: []
}

export default SectionWhy